import { db } from '@core/db';
import { OutlineOperation } from '@/types';

export const outlineOpsRepo = {
  async enqueue(op: OutlineOperation) {
    await db.outlineOps.put(op);
  },

  async listPending(projectId: string, versionId: string) {
    return db.outlineOps
      .where({ projectId, versionId })
      .and((op) => op.syncState !== 'synced')
      .sortBy('createdAt');
  },

  async markSynced(id: string) {
    await db.outlineOps.update(id, { syncState: 'synced' });
  },

  async markFailed(id: string) {
    await db.outlineOps.update(id, { syncState: 'failed' });
  },

  async clearForSection(sectionId: string) {
    const toDelete = await db.outlineOps.where({ sectionId }).toArray();
    await db.outlineOps.bulkDelete(toDelete.map((op) => op.id));
  },
};
